import { DbRef } from "./firebase";
export var OrderProvider;
(function (OrderProvider) {
    OrderProvider["OFFICE"] = "office";
    OrderProvider["PATIENT_OR_CONTACT"] = "patientOrContact";
    OrderProvider["PRESCRIBER"] = "prescriber";
})(OrderProvider || (OrderProvider = {}));
export const BookingRelationshipKeys = {
    procedures: { ref: DbRef.PROCEDURES },
    orderID: { ref: DbRef.ORDERS },
    patientID: { ref: DbRef.USERS },
    providerID: { ref: DbRef.USERS },
    specimenBags: { ref: DbRef.SUPPLY_ITEMS },
};
//# sourceMappingURL=booking.js.map